///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace - use maskIf attributes similar to Vue v-if
// TODO: consolidate into fieldLib
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.maskIf = window.maskIf || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    window.maskIf.init();
});




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.maskIf = {
    init: function() {
        // Find all elements that have a maskIf attribute
        $('*[maskIf]').each(function() {
            var elem = $(this);
            var rule = elem.attr('maskIf').split('|');

            $(rule).each(function() {
                if (this) {
                    window.maskIf._bindElement(elem, this);
                }
            });
        });
    },

    /**
     * Bind the specific element's visibility based on the specified maskIf rule
     * 
     * @param {*} elem 
     * @param {*} rule
     */
    _bindElement(elem, rule) {
        var operator = window.maskIf._findOperator(rule);
        var id = rule.split(operator)[0];
        
        $('#' + id).bind('change', function() {
            var rules = $(elem.attr('maskIf').split('|'));
            var _elem = $(this);
            var found = null;

            $(rules).each(function() {
                var operator = window.maskIf._findOperator(this);
                var value = this.split(operator)[1];
                var mask = value.split(':')[1];
                value = value.split(':')[0];
                var result = window.maskIf._compare(_elem.val(), operator, value);
                //alert(_elem.val() + '\n' + operator + '\n' + value + '\n' + result);
                
                /*
                if (result) {
                    elem.mask(mask, {placeholder: mask.replace(/0/g, '_')});
                } else {
                    elem.unmask();
                }
                */

                if (result) {
                   found = mask;
                }
            });

            if (found) {
                elem.mask(found, {placeholder: found.replace(/0/g, '_')});
            } else {
                elem.unmask();
            }

        }).trigger('change');
    },


    /**
     * Find the operator used in the specified rule
     * 
     * @param {*} rule 
     */
    _findOperator(rule) {
        var operators = ['===', '==', '=', '!==', '!=', '>=', '<=', '>', '<'];
        var found = null;

        $(operators).each(function() {
            if (rule.indexOf(this) > -1) {
                found = this;
            }
        })

        return found;
    },


    /**
     * Compare the two vars using the specified operator
     * 
     * @param {*} var1 
     * @param {*} operator 
     * @param {*} var2 
     */
    _compare(var1, operator, var2) {
        if (operator == '=') return var1 == var2;
        if (operator == '>') return var1 > var2;
        if (operator == '<') return var1 < var2;
        if (operator == '>=') return var1 >= var2;
        if (operator == '<=') return var1 <= var2;
        if (operator == '==') return var1 == var2;
        if (operator == '!=') return var1 != var2;
        if (operator == '===') return var1 === var2;
        if (operator == '!==') return var1 !== var2;

        return null;
    },
}
